import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import authStore from '@/store/auth/auth-store';

export default async function fetchLikes(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    convoUtils.convoService.getNumLikes(convo).then((numLikes: Meta<number>) => {
        // console.log('setting num likes for index: ' + i + ': ' + numLikes.value)
        convoStore.commitSetNumLikes({ convo: convo, numLikes: numLikes.value })
    })
    if (authStore.isAuthenticated) {
        convoUtils.convoService.getIsLiked(convo).then((isLiked: Meta<boolean>) => {
            // console.log('setting num likes for index: ' + i + ': ' + numLikes.value)
            convoStore.commitSetIsLiked({ convo: convo, isLiked: isLiked.value })
        })
    }
    
    return
}
